import Nullstack from 'nullstack';
export default function IconVip({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-vip",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M3 5h18"
  }), "   ", Nullstack.element("path", {
    d: "M3 19h18"
  }), "   ", Nullstack.element("path", {
    d: "M4 9l2 6h1l2 -6"
  }), "   ", Nullstack.element("path", {
    d: "M12 9v6"
  }), "   ", Nullstack.element("path", {
    d: "M16 15v-6h2a2 2 0 1 1 0 4h-2"
  }), " ");
}